export default __webpack_public_path__ + "static/media/neuroscanLogo.d9f7ca05.svg";